exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-secondary[data-v-fc350cd6] {\r\n    margin-right: 1em;\r\n    background-color: transparent;\n}\n.btn-success[data-v-fc350cd6] {\r\n    position: relative;\r\n    min-width: 5rem;\r\n    min-height: 42px;\r\n    border: 2px solid #ffffff;\r\n    text-transform: uppercase;\r\n    font-size: 0.9rem;\r\n    border-radius: 0;\r\n    padding: 1em;\n}\n.btn-success[data-v-fc350cd6]:hover {\r\n    border-color: #fff;\n}\r\n", ""]);

// exports
